<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />
        <div class="card">
          <div class="card-body">
            <div class="row purchase-meta-row">
              <div class="col-lg-4 col-sm-6 col-12">
                <div class="form-group">
                  <label>Supplier Name</label>
                  <model-list-select
                    :list="vendorListFromApi"
                    v-model="forms[0].vendor"
                    option-value="vendorid"
                    option-text="vendorname"
                    placeholder="Select Supplier"
                    @keypress.enter="submitForm()"
                  ></model-list-select>
                </div>
              </div>
              <div class="col-lg-4 col-sm-6 col-12">
                <div class="form-group">
                  <label>Invoice Date</label>
                  <b-form-input
                    type="date"
                    v-model="forms[0].invoicedate"
                    placeholder="Select invoice date"
                    @keypress.enter="submitForm()"
                  ></b-form-input>
                </div>
              </div>
            </div>

            <div v-for="(form, index) in forms" :key="index" ref="formRefs" :class="{ 'additional-form': index > 0 }">
              <div class="row purchase-line-row align-items-end">
                <div class="col-lg-4 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Item Name <span v-if="index > 0" class="purchase-line-label">#{{ index + 1 }}</span></label>
                    <model-list-select
                      :list="itemListFromApi"
                      v-model="form.purchaseitem"
                      option-value="itemid"
                      option-text="itemname"
                      placeholder="Select item"
                      :ref="`purchaseitemInput${index}`"
                      tabindex="1"
                      autofocus
                      @keypress.enter="submitForm()"
                    ></model-list-select>
                  </div>
                </div>
                <div class="col-lg-2 col-sm-4 col-12">
                  <div class="form-group">
                    <label>Quantity</label>
                    <b-form-input
                      type="number"
                      v-model="form.quantity"
                      @input="validateQuantity(form)"
                      min="0"
                      max="999999.99"
                      @keypress.enter="submitForm()"
                    ></b-form-input>
                  </div>
                </div>

                <div class="col-lg-2 col-sm-4 col-12">
                  <div class="form-group">
                    <label>Unit Price</label>
                    <b-form-input
                      type="number"
                      v-model="form.unitprice"
                      @input="validateUnitprice(form)"
                      @keypress.enter="submitForm()"
                    ></b-form-input>
                  </div>
                </div>

                <div class="col-lg-2 col-sm-4 col-8">
                  <div class="form-group">
                    <label>Total Price</label>
                    <b-form-input
                      type="number"
                      v-model="form.totalprice"
                      :disabled="true"
                      @keypress.enter="submitForm()"
                    ></b-form-input>
                  </div>
                </div>
                <div class="col-lg-2 col-sm-4 col-4">
                  <div class="form-group purchase-action-group">
                    <label>&nbsp;</label>
                    <button v-if="index > 0" @click="removeForm(index)" class="btn btn-danger purchase-remove-btn">Remove</button>
                  </div>
                </div>
              </div>

              <hr class="purchase-row-divider"/>
            </div>

            <button @click="addForm" class="btn btn-success me-2">Add More</button>
            <button @click="submitForms" class="btn btn-primary me-2">Submit All</button>
            <router-link to="purchaselist" class="btn btn-secondary">Cancel</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ModelListSelect } from "vue-search-select"
import moment from "moment";
import axios from "axios";
import Swal from "sweetalert2";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';

export default {
  data() {
    return {
      title: "Add Purchase Item",
      title1: "Create new purchase",
      forms: [
        {
          purchaseitem: '',
          invoicedate: moment().format("YYYY-MM-DD"),
          vendor: '',
          quantity: '0',
          unitprice: '0',
          totalprice: '0',
        },
      ],
      itemListFromApi: [],
      vendorListFromApi: [],
    };
  },
  created() {
    this.fetchItemListFromApi();
    this.fetchVendorListFromApi();
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    handleKeydown(event) {
      if (this.$route.path === '/addpurchase' && event.ctrlKey && (event.key === 'm' || event.key === 'M')) {
        event.preventDefault();
        this.addForm();
      }
    },
    validateQuantity(form) {
    const quantity = parseFloat(form.quantity);
    if (quantity < 0) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Quantity',
        text: 'Quantity must be a positive number.',
      });
      form.quantity = Math.max(quantity, 0);
    }
    this.calculateTotalOnChange(form);
  },
  validateUnitprice(form) {
    const unitprice = parseFloat(form.unitprice);
    if (unitprice < 0) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Unitprice',
        text: 'Unitprice must be a positive number.',
      });
      form.unitprice = Math.max(unitprice, 0);
    }
    this.calculateTotalOnChange(form);
  },
    calculateTotalOnChange(form) {
      // Calculate total price based on quantity and unit price
      const unitPrice = parseFloat(form.unitprice);
      const quantity = parseFloat(form.quantity);
      form.totalprice = (isNaN(unitPrice) || isNaN(quantity)) ? '0' : (unitPrice * quantity).toFixed(2);
    },
    addForm() {
      if (this.forms.length < 20) {
        const newIndex = this.forms.length;
        this.forms.push({
          purchaseitem: '',
          invoicedate: this.forms[0].invoicedate,
          vendor: this.forms[0].vendor,
          quantity: '0',
          unitprice: '0',
          totalprice: '0',
        });
       this.$nextTick(() => {
        const newIndex = this.forms.length - 1;
        if (this.$refs[`purchaseitemInput${newIndex}`] && this.$refs[`purchaseitemInput${newIndex}`][0]) {
          this.$refs[`purchaseitemInput${newIndex}`][0].$el.focus();
        }
      });
      } else {
        Swal.fire("You can add a maximum of 20 forms.");
      }
    },
    removeForm(index) {
      this.forms.splice(index, 1);
    },
    
    async fetchItemListFromApi() {
            try {
        const response = await axios.get('/v1/items');
        this.itemListFromApi = response.data;
      } catch (error) {
        console.error('Error fetching item list:', error);
      }
    },

    async fetchVendorListFromApi() {
            try {
        const response = await axios.get('/v1/vendors');
        this.vendorListFromApi = response.data;
      } catch (error) {
        console.error('Error fetching item list:', error);
      }
    },

    postData(forms) {
      forms.forEach(form => {
      form.purchasedate = moment().format("YYYY-MM-DDTHH:mm:ss");
  });
      axios.post('/v1/purchases', forms)
        .then(response => {
          Swal.fire("Purchase created successfully");
          this.$router.push({ path: '/purchaselist' });
        })
        .catch(error => {
          console.log(error);
          Swal.fire(error.response.data.detail);
        });
    },

    async submitForms() {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "Do you really want to submit the form?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, submit it!'
      });

      if (result.isConfirmed) {
      const firstForm = this.forms[0];
      const allFormData = this.forms.map(form => ({
        purchaseitem: form.purchaseitem,
        invoicedate: moment(firstForm.invoicedate).format("YYYY-MM-DDTHH:mm:ss"),
        vendor: firstForm.vendor,
        quantity: form.quantity,
        unitprice: form.unitprice,
        totalprice: form.totalprice,
      }));
      this.postData(allFormData);
      }
    },
    submitForm() {
      this.submitForms();
    },
  },
  components: {
    ModelListSelect,
  },
  name: "addpurchase",
};
</script>

<style scoped>
.purchase-meta-row {
  margin-bottom: 8px;
}

.purchase-line-row {
  margin-bottom: 4px;
}

.purchase-row-divider {
  border-top: 1px solid #e9ecef;
  margin: 6px 0 14px;
}

.purchase-line-label {
  color: #ff9f43;
  font-size: 12px;
  font-weight: 600;
}

.purchase-action-group {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.purchase-remove-btn {
  width: 100%;
}

@media (min-width: 992px) {
  .purchase-line-row :deep(.model-list-select),
  .purchase-line-row :deep(.ui.selection.dropdown),
  .purchase-line-row :deep(input) {
    min-height: 38px;
  }
}
</style>



